module.exports = __webpack_public_path__ + "img/2.5d_4.a24f1ff2.jpg";